import { useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

const useSocketUserDisconnect = () => {
  const { user } = useAuth0();
  const { udasSocket } = useSelector((store) => store?.portal?.udasSocket);

  const userDisconnect = () => {
    udasSocket?.emit('user_disconnect', { tenant_id: user?.stripeId, auth0_id: user?.cxfUserId });
  };

  return { userDisconnect };
}

export default useSocketUserDisconnect;